import { FC, useContext } from 'react';

import { ApplicationContext } from '@App/contexts/Application';

import EligibilityLayout from '../layouts/EligibilityLayout';
import { AlmostCompleteView } from '../views/eligibility/AlmostCompleteView';

const AlmostComplete: FC = () => {
    const { loading } = useContext(ApplicationContext);

    return (
        <EligibilityLayout loading={loading} heightOffset>
            <AlmostCompleteView />
        </EligibilityLayout>
    );
};

export default AlmostComplete;
